var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("m-documents-show-files", {
        attrs: { active: _vm.isShowFilesModal, files: _vm.record.files.items },
        on: {
          close: function ($event) {
            _vm.isShowFilesModal = false
          },
        },
      }),
      _c(
        "div",
        {
          staticClass: "documents-files-cell",
          on: {
            click: function ($event) {
              _vm.isShowFilesModal = true
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.cellValue) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }